const component = require('../component/component');

const action = Object.assign({}, component, {
    subelements: {},
    controller: null,
    action: null,
    itemId: null,
    link: null,
    target: '_self',
    method: 'GET',
    silent: false,
    ignoreRedirects: false,
    disabled: false,
    disableAfterPress: true,
    keepBlocked: false,
    postParams: {},
    formParams: null,

    init: function () {
        component.init.call(this);

        this.element.onclick = (e) => {
            e.preventDefault();
            this.act();
            return false;
        };
    },

    act: async function () {
        if (this.disabled) {
            return false;
        }

        this.element.setAttribute("data-zit-indicator", "on");

        if (this.disableAfterPress) {
            this.disable();
        }

        if (this.silent) {
            if (this.method == 'GET' || this.method == 'POST') {
                await this.silentExecute();
            } else if (this.method == 'triggerLinkedComponent') {
                this.triggerLinkedComponent();
            }

            this.element.removeAttribute("data-zit-indicator");
        } else {
            switch (this.method) {
                case 'GET':
                    this.loudGet();
                    break;

                case 'POST':
                    this.loudPost();
                    break;
            }

            if (this.target !== '_self') {
                this.element.removeAttribute("data-zit-indicator");
            }
        }

        if (this.disableAfterPress && this.keepBlocked === false) {
            this.disable(false);
        } else if (this.disableAfterPress && Number.isInteger(this.keepBlocked)) {
            setTimeout(() => { this.disable(false); }, this.keepBlocked);
        }
    },

    loudGet: function () {
        // 'browserBack' sentinel (used by the back action when no previous web
        // path is known): navigate one step back through the browser history
        // instead of treating it as a URL. Guarded so a fresh tab with no
        // history to return to is a no-op rather than a dead navigation.
        if (this.link === 'browserBack') {
            if (window.history.length > 1) {
                this.hm.app.uiBlock('get');
                window.history.back();
            }
            return;
        }

        if (this.target === '_self') {
            this.hm.app.uiBlock('get');
            window.location.assign(this.link);
        } else {
            window.open(this.link, '_blank');
        }
    },

    loudPost: function () {
        if (this.target === '_self') {
            this.hm.app.uiBlock('post');
        }

        let formElement = null;

        if (this.formId) {
            formElement = document.getElementById(this.formId);
        }

        if (formElement === null) {
            formElement = document.createElement('form');
        }

        let newElements = [];

        for (let paramName in this.postParams) {
            let newParamElement = document.createElement('input');
            newParamElement.type = 'hidden';
            newParamElement.name = paramName;
            newParamElement.value = this.postParams[paramName];

            formElement.appendChild(newParamElement);

            newElements.push(newParamElement);
        }

        let disabledComponents = [];

        //disable all other form elements
        let allFormComponets = this.formComponents('form'); //all the current form's components
        let formComponentsToSubmit = this.formComponents(); //only the components that are supposed to be submitted for this action

        let valid = true;

        allFormComponets.forEach((formComponent) => {
            if (!formComponent.isDisabled() && (!formComponentsToSubmit.includes(formComponent) || formComponent.notSubmittable)) {
                formComponent.disable();
                disabledComponents.push(formComponent);
            } else {
                valid = valid && formComponent.validate();
            }
        });

        if (!valid) {
            this.element.removeAttribute("data-zit-indicator");

            if (this.target === '_self') {
                this.hm.app.uiUnblock('post');
            }
            return false;
        }

        formElement.method = this.method;
        formElement.action = this.link;
        formElement.target = this.target;

        //this.hm.log('loud post', this.target, formElement);

        formElement.submit();

        newElements.forEach((newParamElement) => { newParamElement.remove(); });
        disabledComponents.forEach((disabledComponent) => {
            disabledComponent.enable();
        });
    },

    silentExecute: async function () {
        let fetchConfig = {
            method: this.method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        let formPostData = {};

        if (this.method === 'POST') {
            if (this.itemId !== null) {
                formPostData.id = this.itemId;
            }

            let formComponents = this.formComponents();
            let valid = true;

            formComponents.forEach((formComponent) => {
                if (!formComponent.isDisabled() && !formComponent.notSubmittable) {
                    valid = valid && formComponent.validate();
                    formPostData = Object.assign({}, formPostData, formComponent.formPostData(formPostData));
                }
            });

            if (!valid) {
                return false;
            }

            formPostData = Object.assign({}, formPostData, this.postParams);

            fetchConfig.body = JSON.stringify(formPostData);
        }

        //this.hm.log('silent action', this.method, this.controller, this.action, formPostData);

        let response = await this.hm.app.fetchJson(this.controller, this.action, formPostData, this.method);

        //this.hm.log('response', response);

        if (typeof response._redirect !== typeof undefined && !this.ignoreRedirects) {
            //this.hm.log('redirect', response._redirect);
            if (this.keepBlocked == 'onRedirect') {
                this.keepBlocked = true;
            }
            window.location.assign(response._redirect);
        } else if (this.keepBlocked == 'onRedirect') {
            this.keepBlocked = false;
        }

        if (typeof response.components !== typeof undefined) {
            for (let componentName in response.components) {
                let componentId = componentName;

                if (this.formId) {
                    componentId = this.formId + '_' + componentId;
                }

                if (typeof this.hm.app.components[componentId] !== typeof undefined) {
                    this.hm.app.components[componentId].setValue(response.components[componentName]);
                }
            }
        }

        await this.hm.app.readMessages();

        // Announce the finished request to whatever hosts this action. A surface listens for
        // it to close itself once its submit action came back (see themes/base/components/
        // surface). Bubbling and framework-neutral; only silent actions reach here, a loud
        // one submits natively and the page reloads.
        this.element.dispatchEvent(new CustomEvent('zitActionDone', {
            bubbles: true,
            detail: { action: this, response: response }
        }));

        return response;
    },

    formComponents: function (formParams) {
        if (typeof formParams === typeof undefined) {
            formParams = this.formParams;
        }

        let formComponents = [];
        if (formParams === 'form') {
            formComponents = this.hm.app.formComponents(this.formId);
        } else if (this.hm.helper.isString(formParams)) {
            let formComponentsHolder = document.querySelector('#' + formParams + '_window');
            let formComponentsElements = formComponentsHolder.querySelectorAll('[data-zit-component]');

            formComponentsElements.forEach((formComponentElement) => {
                if (typeof this.hm.app.components[formComponentElement.id] !== typeof undefined) {
                    formComponents.push(this.hm.app.components[formComponentElement.id]);
                }
            });
        } else if (this.hm.helper.isArray(formParams)) {
            formParams.forEach((componentId) => {
                if (typeof this.hm.app.components[componentId] !== typeof undefined) {
                    formComponents.push(this.hm.app.components[componentId]);
                }
            });
        }

        return formComponents;
    },

    triggerLinkedComponent: function () {
        let linkedComponentId = this.controller;
        if (typeof this.hm.app.components[linkedComponentId] !== typeof undefined && this.hm.app.components[linkedComponentId][this.action] !== undefined) {
            let args = [this];
            if (typeof this.extraAttributes.linkedComponentParameters !== typeof undefined) {
                args = this.extraAttributes.linkedComponentParameters;
            }
            this.hm.app.components[linkedComponentId][this.action].call(this.hm.app.components[linkedComponentId], ...args);
        }
    },

    getValue: function () {
        return null;
    },

    block: function (reason) {
        this.disable();
        component.block.call(this, reason);
    },

    release: function (reason) {
        component.release.call(this, reason);
        this.disable(false);
    },

    disable: function (disabled) {
        if (typeof disabled === typeof undefined) {
            disabled = true;
        }

        this.disabled = disabled;
        this.element.disabled = disabled;
    },

    enable: function () {
        this.disable(false);
    }
});

module.exports = action;